module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/5ebaa93bd961d6fa861c56f41ec95f49.svg";